/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { formatDateTime, VisionApplication } from '../../application';
import { VisionLayout } from '../../layout';
import { VisionMapGeofence } from '../../map/geofence';
import { VisionEditPitWindow } from './edit_pit_window';
import { RockPitMap } from './map';
import { RockPitDTO, RockPitService } from './rockpit_service';

export class VisionRockPitsTab {
    app: VisionApplication;

    layout!: dhtmlXLayoutObject;
    grid!: dhtmlXGridObject;
    vehicleGrid!: dhtmlXGridObject;
    completeGrid!: dhtmlXGridObject;
    toolbar!: dhtmlXToolbarObject;

    map!: RockPitMap;
    service: RockPitService;

    private rockPitCache!: Map<string, RockPitDTO>;
    private geofences!: Map<string, VisionMapGeofence>;
    private currentGeofence!: VisionMapGeofence | undefined;

    constructor(vision: VisionLayout) {
        const config: IdhtmlXLayoutConfig = {
            parent: document.body,
            pattern: '3L',
        };

        this.layout = vision.tabbar.cells('ROCK PITS').attachLayout(config);
        this.app = VisionApplication.getInstance();
        this.service = this.app.rockPitService;
        this.rockPitCache = new Map<string, RockPitDTO>();
        this.geofences = new Map<string, VisionMapGeofence>();
        this.currentGeofence = undefined;

        this.setupGUI();
        this.setupEvents();
        this.getPits();
        //this.loadTestData();
    }

    /** Sets up all the GUI elements */
    private setupGUI(): void {
        this.grid = this.layout.cells('a').attachGrid();
        this.layout.cells('a').hideHeader();
        this.grid.setHeader('Name,Capacity,Used,Remaining', '', []);
        this.grid.setEditable(false);
        this.grid.init();
        this.toolbar = this.layout.cells('a').attachToolbar();
        this.toolbar.addButton('new', 1, 'Add Pit', 'css/imgs/new.gif', '');

        this.layout.cells('c').setText('Vehicle Summary');
        this.vehicleGrid = this.layout.cells('c').attachGrid();
        this.vehicleGrid.setHeader('Vehicle,Date,Tons', '', []);
        this.vehicleGrid.init();
        this.map = new RockPitMap(this);
    }

    private getPits() {
        this.grid.clearAll(false);
        const request = this.service.cachedFetchData();
        request.then((data) => {
            data.forEach((pit) => {
                this.addRockPit(pit);
            });
        });
    }

    private addRockPit(pit: RockPitDTO): void {
        this.rockPitCache.set(pit.id.id, pit);

        this.grid.addRow(pit.id.id, [pit.id.name, pit.capacity, pit.used, Math.round(pit.capacity - pit.used)], 0, '', '', false);
    }

    private setupEvents(): void {
        const app = VisionApplication.getInstance();
        this.toolbar.attachEvent('onClick', (itemId) => {
            if (itemId == 'new') {
                //const window = new VisionEditPitWindow(app.windowManager);
                new VisionEditPitWindow(app.windowManager);
            }
        });

        this.grid.attachEvent('onRowSelect', (rid) => {
            this.showPitInfo(rid);
        });
    }

    private showPitInfo(rid: string): void {
        const pit = this.rockPitCache.get(rid);
        let geo = undefined;
        if (pit) {
            geo = this.geofences.get(rid);
            if (geo == undefined) {
                geo = new VisionMapGeofence(this.map.map);
                if (pit) {
                    geo.createGeofence(pit.geometry, pit.colour, 1);
                    this.geofences.set(pit.id.id, geo);
                }
            }
        }

        if (this.currentGeofence != undefined) {
            this.currentGeofence.polygon.setMap(null);
        }

        if (geo != undefined) {
            this.currentGeofence = geo;
            this.currentGeofence.polygon.setMap(this.map.map.map);
            this.map.map.map.panToBounds(this.currentGeofence.bounds);
        }

        this.showVehicleData(rid);
    }

    private showVehicleData(id: string) {
        const request = this.service.getEvents(id);
        request.then((data) => {
            this.vehicleGrid.clearAll(false);
            let rid = 1;
            data.parsedBody?.forEach((row) => {
                const asset = this.app.assetService.assetList.get(row.assetId);
                let name = 'N/A';
                let tons = 0;
                if (asset) {
                    name = asset.id.name;
                    tons = asset.config.rockCapacity;
                }
                this.vehicleGrid.addRow(rid, [name, formatDateTime(row.timestamp), tons], 0, '', '', false);
                rid += 1;
            });
        });

        /*
        var orgid = VisionApplication.getInstance().assetService.orgid;
        if ( orgid == '49680f44-221d-4a25-a56e-b6a1afd95e8b') {

        this.vehicleGrid.clearAll(false);
        this.vehicleGrid.addRow(1, [
            "Rock Truck 1",
            "01/10/2025",
            "3",
            "734"
        ], 0, "", "", false);        

        this.vehicleGrid.addRow(2, [
            "Rock Truck 2",
            "01/11/2025",
            "2",
            "546"
        ], 0, "", "", false);        

        this.vehicleGrid.addRow(3, [
            "Rock Truck 3",
            "01/12/2025",
            "1",
            "131"
        ], 0, "", "", false);        
    }
        */
    }
}
